const home = {
  hero: {
    title: "开云平台",
    subtitle: "安全可信赖的首选平台",
    description: "提供安全稳定的登录体验、丰富的功能服务与专业客服支持。7×24小时全天候服务保障您的每一次操作。",
    cta: "立即体验",
    secondaryCta: "了解更多",
  },
  features: {
    title: "为什么选择开云平台",
    subtitle: "我们致力于为用户提供卓越的平台服务体验",
    items: [
      {
        title: "安全可靠",
        description: "多重安全防护机制，全方位保障您的账户安全与数据隐私。",
        icon: "ri-shield-check-line",
      },
      {
        title: "稳定流畅",
        description: "高性能服务器架构，确保平台运行稳定，体验流畅不卡顿。",
        icon: "ri-rocket-line",
      },
      {
        title: "专业客服",
        description: "7×24小时全天候在线客服团队，快速响应您的每一个问题。",
        icon: "ri-customer-service-2-line",
      },
      {
        title: "持续创新",
        description: "不断优化产品功能，为您带来更好的使用体验。",
        icon: "ri-lightbulb-flash-line",
      },
    ],
  },
  stats: {
    users: "累计用户",
    satisfaction: "用户满意度",
    supportHours: "客服在线时长",
    responseTime: "平均响应时间",
  },
  latestArticles: {
    title: "最新资讯",
    subtitle: "了解开云平台最新动态与使用指南",
  },
  faq: {
    title: "常见问题",
    subtitle: "快速解答您的疑问",
    items: [
      {
        question: "如何注册开云平台账户？",
        answer: '访问开云平台官网，点击右上角\u201C注册\u201D按钮，填写用户名、密码、手机号等信息，阅读并同意服务条款后即可完成注册。',
      },
      {
        question: "忘记密码怎么办？",
        answer: '在登录页面点击\u201C忘记密码\u201D，通过绑定的手机号或邮箱接收验证码，按照提示即可重置密码。',
      },
      {
        question: "开云平台支持哪些设备？",
        answer: "开云平台支持电脑端（Windows/Mac）、手机端（iOS/Android）和平板设备，您可以根据需要选择合适的设备使用。",
      },
      {
        question: "如何联系客服？",
        answer: "您可以通过平台右下角的在线客服图标、客服热线400-XXX-XXXX或发送邮件至support@kaiyun.com联系我们的客服团队。",
      },
      {
        question: "账户安全如何保障？",
        answer: "我们采用多重加密技术保护您的数据安全，支持短信验证、邮箱验证、人脸识别等多种验证方式，全方位保障账户安全。",
      },
    ],
  },
  cta: {
    title: "准备好开始了吗？",
    subtitle: "立即加入开云平台，体验安全可靠的一站式服务",
    button: "立即注册体验",
  },
};

export default home;